import styled from 'styled-components';
import {
  color,
  typography,
  variant,
  space,
  ColorProps,
  SpaceProps,
  TypographyProps,
} from 'styled-system';

export type ContainerProps = TypographyProps &
  ColorProps &
  SpaceProps &
  Record<string, any> & {
    variant?: string;
    display?: string;
    maxWidth?: string;
    overflow?: string;
  };

export const Container = styled('span')<ContainerProps>`
  display: ${({ display }) => display || 'inline-flex'};
  max-width: ${({ maxWidth }) => maxWidth || '280px'};
  overflow: ${({ overflow }) => overflow || 'hidden'};

  ${variant({
    scale: 'textStyles',
  })}
  ${color}
  ${space}
  ${typography}
`;
